import { useEffect, useState } from 'react';
import { api } from '../api';

export default function ClientPage() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState('');
  const [logo, setLogo] = useState(null);
  const [editId, setEditId] = useState(null);

  const load = () => api.clients.list().then(setItems).catch((error) => alert(error.message));
  useEffect(() => { load(); }, []);

  const submit = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('client_name', name);
    if (logo) formData.append('logo', logo);
    api.clients.save(editId, formData)
      .then(() => { setName(''); setLogo(null); setEditId(null); load(); })
      .catch((error) => alert(error.response?.data?.message || error.message));
  };

  return (
    <>
      <h2>고객사</h2>
      <form onSubmit={submit}>
        <input placeholder="고객사명" value={name} onChange={(e) => setName(e.target.value)} required />
        <input type="file" accept="image/*" onChange={(e) => setLogo(e.target.files[0])} />
        <div className="row">
          <button type="submit">{editId ? '수정' : '추가'}</button>
          <button type="button" className="ghost" onClick={() => { setName(''); setLogo(null); setEditId(null); }}>취소</button>
        </div>
      </form>
      <div className="row">
        {items.map((item) => (
          <div className="card" key={item.client_id}>
            <div>{item.client_name}</div>
            {item.logo_url && <img className="thumb" src={item.logo_url} alt={item.client_name} />}
            <div className="row">
              <button type="button" onClick={() => { setEditId(item.client_id); setName(item.client_name); }}>수정</button>
              <button type="button" className="danger" onClick={() => window.confirm('삭제할까요?') && api.clients.remove(item.client_id).then(load)}>삭제</button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
